import { render, staticRenderFns } from "./NabadoonVue.vue?vue&type=template&id=0a74dcaa&scoped=true&"
import script from "./NabadoonVue.vue?vue&type=script&lang=js&"
export * from "./NabadoonVue.vue?vue&type=script&lang=js&"
import style0 from "./NabadoonVue.vue?vue&type=style&index=0&id=0a74dcaa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a74dcaa",
  null
  
)

export default component.exports